import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    constructor(private http: HttpClient) { }

    isAuthenticated(): Observable<boolean> {
        const tokenEndpoint = environment.uriCSEndpoint + 'credential/v2/refresh';

        return this.http.get(tokenEndpoint).pipe( map((res) => {
            if (res) {
                return true;
            } else {
                return false;
            }
        }),
        catchError(error => {
            return of(false);
        }));
    }
}
